import styled from "styled-components";
import { theme } from "./theme";

export const FormGroup = styled.div`
  margin-bottom: 1.8rem;
  position: relative;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 0.7rem;
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.white};
  font-size: ${theme.fontSizes.small};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 1rem 1.2rem;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: ${theme.borderRadius.medium};
  font-size: ${theme.fontSizes.regular};
  background: rgba(255, 255, 255, 0.1);
  color: ${theme.colors.white};
  backdrop-filter: blur(10px);

  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0 0 0 3px rgba(255, 210, 0, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const PasswordField = styled.div`
  position: relative;
`;

export const PasswordInput = styled(Input)`
  padding-right: 3rem;
`;

export const PasswordToggle = styled.button`
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.75);
  padding: 0.35rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    color: ${theme.colors.primary};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.span`
  color: ${theme.colors.error};
  font-size: ${theme.fontSizes.small};
  margin-top: 0.5rem;
  display: block;
  font-weight: ${theme.fontWeights.medium};
`;

export const Button = styled.button`
  background: linear-gradient(135deg, ${theme.colors.primary} 0%, #e6bd00 100%);
  color: ${theme.colors.secondary};
  border: none;
  border-radius: ${theme.borderRadius.medium};
  padding: 1rem 2rem;
  font-size: ${theme.fontSizes.regular};
  font-weight: ${theme.fontWeights.bold};
  cursor: pointer;
  width: 100%;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(255, 210, 0, 0.3);

  &:hover:not(:disabled) {
    box-shadow: 0 6px 20px rgba(255, 210, 0, 0.4);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const AuthLink = styled.a`
  color: ${theme.colors.primary};
  text-decoration: none;
  font-weight: ${theme.fontWeights.medium};
  font-size: ${theme.fontSizes.small};

  &:hover {
    text-decoration: underline;
    color: #e6bd00;
  }
`;

export const LinkRow = styled.div`
  margin-top: 1.25rem;
  text-align: center;
`;

export const ForgotLinkRow = styled.div`
  text-align: right;
  margin-bottom: 1.5rem;
`;

export const LoadingSpinner = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  border-top-color: ${theme.colors.secondary};
  animation: spin 1s ease-in-out infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.7;
  }
`;

export const FormSection = styled.div`
  margin-bottom: 2rem;
`;

export const DividerLine = styled.div`
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  margin: 2rem 0;
`;
